import React, { useState, useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import OtpInput from 'react-otp-input';
import { loadUser, getAuthSession, loginWithOTP } from '../../store/authSlice';
import { parseToInt, reverseUrl } from '../../utils/helpers';
import Spinner from '../../layout/Spinner';

const OtpLogin = () => {
  const dispatch = useDispatch();
  const { redirect } = useParams();

  const { user, signData, authSession, doneLoadingAuthSession } = useSelector((state) => state.auth);
  const { width } = useSelector((state) => state.general);
  const [email, setEmail] = useState();
  const [otp, setOtp] = useState('');
  const [getAuthSessionClicked, setGetAuthSessionClicked] = useState(false);
  const [loginClicked, setLoginClicked] = useState(false);
  const [waitAwhile, setWaitAwhile] = useState(false);
  const isMobile = width <= 768;

  const loggedIn = user && user._id;
  useEffect(() => {
    dispatch(loadUser(user?._id));
    setTimeout(() => {
      setWaitAwhile(true);
    }, 3000);
  }, []);
  console.log({ authSession, otp });
  if (signData) return <Navigate to={`/loginuser/${signData}`} />;
  if (loggedIn) {
    return <Navigate to={`${reverseUrl(redirect) || '/profile'}`} />;
  }
  return waitAwhile ? (
    <div className='container mt-5'>
      <div
        className='col-lg-12 d-flex justify-content-center order-1 order-lg-2 hero-img'
        style={isMobile ? {} : { width: '35%', marginLeft: '32%' }}
        data-aos='zoom-in'
        data-aos-delay='200'
      >
        <img src='/assets/img/hero-img.png' className='img-fluid animated' alt='main_image' />
      </div>
      <div className='row d-flex justify-content-center p-4 mt-4'>
        <div className='col-md-6'>
          <div className='form mb-4'>
            <input
              type='email'
              id='form2Example1'
              style={{ textAlign: 'center' }}
              placeholder='Email address...'
              className='form-control'
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <label className='form-label'>Email address</label>
          </div>

          {authSession?.error ? (
            <div className='d-flex justify-content-center mb-2'>
              <h5 className='text-danger'>{authSession.error}</h5>
            </div>
          ) : null}
          {/(.+)@(.+){2,}\.(.+){2,}/.test(email) ? (
            <>
              {getAuthSessionClicked && !doneLoadingAuthSession ? (
                <Spinner />
              ) : (
                <>
                  {authSession ? null : (
                    <button
                      type='button'
                      className='btn btn-outline-dark btn-block'
                      onClick={() => {
                        dispatch(getAuthSession(email));
                        setGetAuthSessionClicked(true);
                      }}
                    >
                      Get OTP
                    </button>
                  )}
                </>
              )}
            </>
          ) : null}
        </div>
      </div>
      {authSession?.authSessionId ? (
        <>
          <div className='row d-flex justify-content-center'>
            <h3>Enter the OTP you got in your email</h3>
          </div>
          <div className='row d-flex justify-content-center mt-2'>
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              renderSeparator={<span>-</span>}
              renderInput={(props) => <input {...props} className='border' />}
              separator={<span style={{ width: '8px' }}></span>}
              isInputNum={true}
              shouldAutoFocus={true}
              inputStyle={{
                border: '1px solid transparent',
                borderRadius: '8px',
                width: '54px',
                height: '54px',
                fontSize: '12px',
                color: '#000',
                fontWeight: '400',
                caretColor: 'blue',
              }}
              focusStyle={{
                border: '1px solid #CFD3DB',
                outline: 'none',
              }}
            />
          </div>
          {otp && otp.length === 6 && typeof parseToInt(otp) === 'number' ? (
            <div className='row d-flex justify-content-center mt-4'>
              {loginClicked ? (
                <Spinner />
              ) : (
                <button
                  className='btn btn-lg btn-outline-success'
                  onClick={() => {
                    dispatch(loginWithOTP({ email, otp: parseToInt(otp), authSessionId: authSession.authSessionId }));
                    setLoginClicked(true);
                  }}
                >
                  Login
                </button>
              )}
            </div>
          ) : null}
        </>
      ) : null}
    </div>
  ) : (
    <Spinner width='150' />
  );
};

export default OtpLogin;
